import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ReportItemsImportDialogData, ReportItemsImportSkippedRow } from '../../models/dialog.model';

/** Beyond this the skipped list stops being a list and starts being a wall. */
const SKIPPED_ROWS_SHOWN = 25;

@Component({
  selector: 'app-report-items-import-dialog',
  templateUrl: './report-items-import-dialog.component.html',
  styleUrl: './report-items-import-dialog.component.scss'
})
export class ReportItemsImportDialogComponent {
  readonly dialogRef = inject(MatDialogRef<ReportItemsImportDialogComponent, boolean>);
  readonly data = inject<ReportItemsImportDialogData>(MAT_DIALOG_DATA);

  get applyCount(): number {
    return this.data.updateCount + this.data.addCount;
  }

  get visibleSkippedRows(): ReportItemsImportSkippedRow[] {
    return this.data.skippedRows.slice(0, SKIPPED_ROWS_SHOWN);
  }

  get hiddenSkippedCount(): number {
    return Math.max(0, this.data.skippedRows.length - SKIPPED_ROWS_SHOWN);
  }

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
